import { render } from "./ProductNav.vue?vue&type=template&id=b3297d8a&scoped=true"
import script from "./ProductNav.vue?vue&type=script&lang=js"
export * from "./ProductNav.vue?vue&type=script&lang=js"

import "./ProductNav.vue?vue&type=style&index=0&id=b3297d8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3297d8a"]])

export default __exports__